import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeftChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M674 68L240 503L675 937L730 882L348 502L730 123Z" })
});
export default SvgLeftChevron;
